import React, { useEffect, useState } from 'react';
import HelpBackIcon from './../../../../../images/helpbackicon.png'
import {Link, useNavigate} from 'react-router-dom'

function YoutubeMonetize() { 
    const [feedback,setFeedback] = useState(false)
    const navigate= useNavigate();

    return (
        <div style={{backgroundImage:`url("https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/yovww6fxrbmtzfqlpy0z")`,backgroundPositionX:'-1em',backgroundSize:'100%'}}>

        <div style={{         
        display:'flex',
        flexDirection:'column',
        alignItems:'center',
        zIndex:'1',
        height:'9.63em'
        }}/>

        <div style={{
              backgroundColor:'#F9FCFF',
              width:'100%',
              display:'flex',
              flexDirection:'column',
              alignItems:'center',
              paddingBottom:'5.5em',
              minHeight: '72vh', height: 'auto'
        }}>
            <div style={{
                display:'flex',
                flexDirection:'column',
                alignItems:'flex-start',
                width:'70%',
                paddingTop:'2.5em'
            }}>

                <div style={{
                    display:'flex',
                    flexDirection:'row',
                    alignItems:'center',
                    cursor:'pointer'
                   
                }} onClick={()=>{navigate("/help");setFeedback(false)}}>
                    <img src={HelpBackIcon} style={{width:'1.5em',height:'1.5em',marginRight:'0.25em',cursor:'pointer'}}/>
                    <div className="backTxt">Back</div>
                </div>

                <div className="infoHeader">
                YouTube Monetization
                </div>

                <div className="infoDescHeader" style={{marginTop:'0em'}}>
                UGC & RIGHTS MANAGEMENT
                </div>

                <div className="infoDesc">
                N3RVE offers the most powerful user-generated content and rights management service in the industry. We ensure that all your creative works are protected and monetized efficiently.
                </div>

                <div className="infoDesc">
                <br/>Our partners are the best in the biz. With our YouTube Monetization Service, you can easily monetize your YouTube videos. Our platform identifies and claims unauthorized uses of your content, ensuring you get paid. We provide detailed analytics to track your performance and offer global reach to expand your audience. Focus on creating great content while we handles the monetization and rights management.
                </div>

                <div className="infoDesc">
                <br/>To Turn your YouTube views into revenue, you can access our submission page <span  style={{color:'#C7A5FF',cursor:'pointer',fontWeight:'500'}} onClick={()=>navigate("/monetize")}>HERE</span>
                </div>


                {
                    !feedback &&
                    <div>
                         <div className="infoDesc" style={{marginTop:'6.5em'}}>
                            Was this article helpful?
                            </div>

                            <div style={{display:'flex',flexDirection:'row'}}>
                                <div className="helpfulBtn" onClick={()=>setFeedback(true)}>
                                    YES
                                </div>

                                <div className="helpfulBtn" onClick={()=>setFeedback(true)}>
                                    NO
                                </div>
                            </div>
                    </div>
                }

                {
                    feedback &&
                    
                         <div className="infoDesc" style={{marginTop:'8.5em'}}>
                           Thank you for your feedback
                            </div>

                         
                    
                }
               
            </div>

        </div>
        
        
       
    </div>
    )
}


export default YoutubeMonetize;